export const pillars = ['Method', 'Memory', 'Organization', 'Orals', 'Anxiety', 'Results'];

export const volumes = [
  {
    n: 1,
    emoji: '📕',
    title: 'GPA Architecture',
    desc: 'Strategic planning framework to build and maintain a perfect grade point average from day one. The blueprint top-performing students use to stay ahead of every deadline, exam and professor expectation.',
  },
  {
    n: 2,
    emoji: '📗',
    title: 'Neural Recall System',
    desc: 'Master Spaced Repetition and Active Recall to retain information at a level most students never reach. Stop forgetting everything the night after studying and own the material permanently.',
  },
  {
    n: 3,
    emoji: '📘',
    title: 'The Deep Work Protocol',
    desc: 'How to achieve uninterrupted concentration in the age of TikTok, Instagram and constant notifications. The exact system to enter a Flow State on command and study twice as much in half the time.',
  },
  {
    n: 4,
    emoji: '📙',
    title: 'AI-Powered Scholar',
    desc: 'How to use ChatGPT and Claude to research 3x faster, summarize complex academic texts instantly and generate personalized practice questions directly from your syllabus material.',
  },
  {
    n: 5,
    emoji: '📓',
    title: 'Note-Taking Elite',
    desc: 'Stop transcribing lectures word for word. Master the Cornell System and Zettelkasten Method applied to digital environments so your notes become 80% of the study already done.',
  },
  {
    n: 6,
    emoji: '📒',
    title: 'Exam Mastery',
    desc: 'The psychology and tactical framework to dominate any exam under pressure. Predict what professors will ask, structure perfect written answers and eliminate the blank-out response permanently.',
  },
  {
    n: 7,
    emoji: '📕',
    title: 'Speed Reading Lab',
    desc: 'Absorb dense academic and technical information at high velocity without sacrificing comprehension. The exact techniques used by top Medical and Law students to process 300+ pages per week.',
  },
  {
    n: 8,
    emoji: '📗',
    title: 'Burnout Shield',
    desc: 'Stress management, sleep cycle optimization and university mental health protocols. The biological and psychological system to maintain elite performance without collapsing at the finish line.',
  },
  {
    n: 9,
    emoji: '📘',
    title: 'Scientific Writing Mastery',
    desc: 'Essay and thesis structure at superior academic level. How to write papers, reports and assignments that consistently score in the top 10% of your class and make professors take notice.',
  },
  {
    n: 10,
    emoji: '📙',
    title: 'Finances & Freedom',
    desc: 'Budgeting systems and scholarship strategies for university students. How to eliminate financial stress permanently so it never becomes a silent academic performance killer.',
  },
  {
    n: 11,
    emoji: '📓',
    title: 'Networking Power',
    desc: 'How to land internships at Fortune 500 companies before graduation. The exact LinkedIn and email scripts to contact professors, recruiters and high-level mentors without sounding desperate.',
  },
  {
    n: 12,
    emoji: '📒',
    title: 'Future Launch',
    desc: 'The complete transition guide from campus to the elite professional market. How to convert your academic record into a personal brand that attracts six-figure opportunities before you graduate.',
  },
];

export const volumeIncludes = [
  'Ready-to-apply techniques',
  'Step-by-step protocols',
  'Editable templates',
  'Real university case studies',
  'Implementation checklists',
  'Strategies for working students',
  'Anglo-Saxon university system adapted',
  'Ready to apply from today',
];

export const bonuses = [
  {
    n: '01',
    title: 'THE AI PROMPT LIBRARY (PDF)',
    desc: 'The definitive database of ready-to-use prompts for ChatGPT and Claude. Built for university students to summarize dense academic texts, explain complex concepts in plain language and generate custom practice questionnaires in seconds.',
    price: '$14',
  },
  {
    n: '02',
    title: 'THE HIGH-PERFORMANCE NOTION TEMPLATE (Digital)',
    desc: 'Your complete academic command center. A fully pre-configured Notion ecosystem to manage exam calendars, lecture note databases, assignment trackers and weekly habit systems — all in one place.',
    price: '$10',
  },
  {
    n: '03',
    title: 'THE 24-HOUR EXAM EMERGENCY CHECKLIST (Template)',
    desc: 'The rescue protocol for when you only have 24 hours left. Exactly what to study, what to ignore completely and how to prime your brain for maximum retention under extreme time pressure.',
    price: '$9',
  },
  {
    n: '04',
    title: 'THE IVY LEAGUE NETWORKING SCRIPTS (PDF)',
    desc: 'Exact word-for-word message templates for LinkedIn and cold email outreach. Contact professors, corporate recruiters and high-value mentors without sounding desperate, generic or inexperienced.',
    price: '$7',
  },
  {
    n: '05',
    title: 'THE STUDENT SIDE-HUSTLE BLUEPRINT (PDF)',
    desc: 'A practical step-by-step guide to generating your first $500 - $1,000 extra per month while studying full-time, without sacrificing your GPA or your sanity. Focused on digital freelancing skills.',
    price: '$5',
  },
];
